import { Component, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-dialog-content',
  templateUrl: './dialog-content.html',
  styleUrl: './dialog-content.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'dialog-content',
  },
})
export class DialogContent {}
